import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionScripts } from "../../../_helpers/actionScripts";
import TitleBar from "../../_common/TitleBar";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from "reactflow";

import "reactflow/dist/style.css";
import qmsRolePermissionActions from "../../../_actions/_qmsActions/qmsRolePermissionActions";
import QmsDivisionSelector from "../_common/QmsDivisionSelector";
import qmsUserActions from "../../../_actions/_qmsActions/qmsUserActions";

export default function QmsDashboard(props) {
  const {} = props;

  const dispatch = useDispatch();
  const [selectedDivision, setDivision] = useState(null);

  const proDmsUser = useSelector((state) => state.authentication.user || null);
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);
  const proDmsUserId = useSelector((state) => state.authentication.user.userId);

  useEffect(() => {
    dispatch(qmsRolePermissionActions.getPermissionScopesAndActions());
    dispatch(qmsUserActions.getUserRoles());
    dispatch(qmsRolePermissionActions.get(proDmsUserId));
    if (proDmsUser) dispatch(qmsUserActions.getByProDmsUserId(proDmsUser.userId, true));
  }, []);

  const permissionScopes = useSelector((state) => state.qms.permissionScopes || null);

  // Access to QMS Admin is based on qmsUser.userRoleValue (not permissions) -
  // check access to individual portions of QMS Admin using permissions.
  const adminAccessIsAuthorized = useMemo(() => {
    if (!qmsUser || !permissionScopes) return false;
    return qmsUser.userRoleValue > 1;
  }, [permissionScopes, qmsUser]);

  return (
    <>
      <TitleBar titleText="QMS - Dashboard" menu={null} handleTitleBarAction={() => {}} />
      <div className="row mx-0">
        <div className="col-12 px-2">
          <QmsDivisionSelector setDivision={setDivision} />
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-12 px-2">
          <div className="d-flex flex-row w-100">
            <button
              id="cmt"
              name="cmt"
              onClick={() => actionScripts.OPEN_QMS_CMT_LIST.run(selectedDivision.value)}
              className="btn btn-secondary mr-2"
              disabled={!selectedDivision}
            >
              <FontAwesomeIcon icon="cubes" className="fa-fw mr-2" />
              Change Management Tracker
            </button>
            {adminAccessIsAuthorized && (
              <button
                id="qmsAdmin"
                name="qmsAdmin"
                onClick={() => actionScripts.OPEN_QMS_ADMIN.run()}
                className="btn btn-secondary"
              >
                <FontAwesomeIcon icon="cogs" className="fa-fw mr-2" />
                QMS Admin
              </button>
            )}
          </div>
        </div>
        <div className="card m-2 w-100">
          <div className="card-body p-3" style={{ height: "500px", width: "100%" }}>
            {/* <Flow /> */}
          </div>
        </div>
      </div>
    </>
  );
}

const initialNodes = [
  { id: "1", position: { x: 0, y: 0 }, data: { label: "1" } },
  { id: "2", position: { x: 0, y: 100 }, data: { label: "2" } },
];

const initialEdges = [{ id: "e1-2", source: "1", target: "2" }];

function Flow() {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
    >
      <MiniMap />
      <Controls />
      <Background />
    </ReactFlow>
  );
}
